import styled from 'styled-components'

import AddConversionReportFormUnstyled from 'Containers/Form/Campaigns/AddConversionReport/unstyled'

export const AddConversionReportForm = styled(AddConversionReportFormUnstyled)`
  margin: 0 -15px;

  .row {
    margin: 0 0 30px 0;
  }

  .row:last-child {
    margin: 0;
  }
  .upload-report {
    cursor: pointer;
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/AddConversionReport/index.js